export default {
  FAQS_MGMT_LIST_REQUEST: 'APP/FAQS_MGMT/FAQS_MGMT_LIST_REQUEST',
  FAQS_MGMT_LIST_SUCCESS: 'APP/FAQS_MGMT/FAQS_MGMT_LIST_SUCCESS',
  FAQS_MGMT_LIST_ERROR: 'APP/FAQS_MGMT/FAQS_MGMT_LIST_ERROR',
};
